export default {
  data() {
    return {
      activeProducts: {
        home: null,
        lot: null,
        facade: null
      },
      activeIds: {
        homeid: null,
        lotid: null,
        lotcpid: null,
        facadeid: null
      },
      sub: null
    }
  },
  created() {},
  mounted() {
    this.sub = this.$store.subscribe((mutation, state) => {
      if (mutation.type === "setHomeDetail") {
        this.activeProducts.home = state.communityStore.homeDetail
      }
    });
  },
  beforeDestroy() {
    this.sub();
  },
  methods: {
    getIds: function () {
      const query = this.$route.query;
      if (query.homeid) {
        this.activeIds.homeid = query.homeid;
      }
      if (query.lotid) {
        this.activeIds.lotid = query.lotid;
      }
      if (query.lotcpid) {
        this.activeIds.lotcpid = query.lotcpid;
      }
      if (query.facadeid) {
        this.activeIds.facadeid = query.facadeid;
      }
      return this.activeIds;
    },

    goToFacade: function () {
      this.getIds();
      if (this.activeIds.lotid && this.activeIds.lotcpid && this.activeIds.homeid) {
        return this.$router.push({
          path: '/community/facade',
          query: {
            homeid: this.activeIds.homeid,
            lotid: this.activeIds.lotid,
            lotcpid: this.activeIds.lotcpid
          }
        })
      } else if (this.activeIds.homeid) {
        return this.$router.push({
          path: '/community/facade',
          query: {
            homeid: this.activeIds.homeid
          }
        })
      }
    },

    goToPackage: function () {
      this.getIds();
      if (this.activeIds.lotid && this.activeIds.facadeid && this.activeIds.homeid) {
        const ids = {
          'plancpid': this.activeIds.homeid,
          'lotcpid': this.activeIds.lotid,
          'facadecpid': this.activeIds.facadeid,
          'customerCreated': true,
          'customprice': this.activeProducts.home ? this.activeProducts.home.productprice : null
        }
        this.$store.dispatch('createPackage', ids)
      }
    },

    setIds: function (ids) {
      ids.forEach(id => {
        if (this.activeIds.hasOwnProperty(id.key)) {
          this.activeIds[id.key] = id.value;
        }
      })

    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/journey/Journey.js